module.exports = __webpack_public_path__ + "img/background2.2af5cf0f.png";